/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 08:59:54
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-04-12, 12:27:14
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import ENUM from "es6-enum";
import { createAction } from "helpers/utils";

const GET_COMPLAINS_LIST = ENUM('STATIC', 'SUCCESS', 'FAIL');

const initialState = {
  list: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_COMPLAINS_LIST.STATIC:
      return {
        ...state
      };
    case GET_COMPLAINS_LIST.SUCCESS:
      return {
        ...state,
        list: action.result
      };
    case GET_COMPLAINS_LIST.FAIL:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}

/**
 * Get complains list.
 * 
 * @export
 * @param {number} [page=1] 
 * @param {number} [brand=0] 
 * @returns 
 */
export function getComplainsList(page = 1, brand = 0, search = {}) {
  return createAction(GET_COMPLAINS_LIST, `/complains?page=${page}&brands_id_fk=${brand}${search.email? `&email=${search.email}` : ''}${search.number? `&number=${search.number}` : ''}`, 'get');
}


// WEBPACK FOOTER //
// ./src/rcapp/redux/actions/complains.js